import API from '@/views/Fdc/Apis/'
import _ from 'lodash'

/**
 * Detection > Model Condition Grid component
 */
export default {
  name: 'ModelConditionGrid',
  props: {
    // 'UVA' 또는 'MVA'
    modelType: {
      type: String,
      default: ''
    },
    modelRowData: {
      type: Object,
      default () {
        return null
      }
    }
  },
  watch: {
    /**
     * rowData 변화 감지
     */
    rowData: function () {
      this.updateComboBoxInGrid()
    },
    /**
     * modelRowData 변화 감지
     */
    modelRowData: function () {
      let data = this.modelRowData
      if (data === null || data.briqueGridCud === 'C') {
        this.rowData = []
        this.originRowData = []
      } else if (Object.keys(data).length === 0) {
        this.rowData = []
        this.originRowData = []
      } else {
        this.listFn(data)
      }
    }
  },
  beforeMount () {
    this.initColumns()
  },
  methods: {
    // BRIQUE GRID 관련 method - start
    /**
     * Grid columns 초기화
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.SEQ'), field: 'condSeq', width: 80, required: true, editable: false, type: 'numericColumn', rowDrag: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_NAME'), field: 'contextName', width: 120, required: true, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_DATA'), field: 'contextData', width: 120, required: true, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_OPERATION'), field: 'contextOptr', width: 100, required: true, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOGIC_OPERATION'), field: 'logicOptr', width: 110, required: true, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 130, editable: false, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 100, editable: false }
      ]
    },
    /**
     * Detection Model이 있는지 여부 체크
     * @returns {Boolean} 선택된 Detection Model이 있는지 여부
     * Model Condition 관련 Button을 제어합니다.
     */
    hasModelRow () {
      if (this.modelRowData === null) {
        return false
      } else if (Object.keys(this.modelRowData).length === 0) {
        return false
      } else if (this.modelRowData.briqueGridCud && this.modelRowData.briqueGridCud === 'C') {
        return false
      } else {
        return true
      }
    },
    /**
     * Model Condition grid에 check된 row가 있는지 체크
     * @returns {*} check된 row가 있는지 여부
     */
    hasCheckedRows () {
      if (!this.$refs.modelConditionGrd) {
        return 0
      }
      return this.$refs.modelConditionGrd.checkedRowCount > 0
    },
    /**
     * Model Condition 목록 조회
     * @param {*} paramData 선택된 Detection Model data
     */
    async listFn (paramData) {
      let payload
      if (this.modelType === 'MVA') {
        payload = {
          fab: paramData.fab,
          eqpId: paramData.eqpId,
          moduleId: paramData.moduleId,
          modelName: paramData.modelName,
          modelType: this.modelType,
          recipeId: paramData.recipeId,
          stepId: 'ALL'
        }
      } else {
        payload = {
          fab: paramData.fab,
          eqpId: paramData.eqpId,
          moduleId: paramData.moduleId,
          modelName: paramData.paramName,
          modelType: this.modelType,
          recipeId: paramData.recipeId,
          stepId: paramData.stepId
        }
      }
      let data = await API.Model.getModelConditions(payload)
      this.rowData = data
      this.originRowData = data

      this.getMaxCondSeq(payload).then((result) => {
        this.maxCondSeq = result
      })
      // this.modelConditionGrd.select(-1, -1)
    },
    /**
     * Model Conditino grid에 신규 row 추가
     */
    newRowAdd () {
      let baseData = this.modelRowData
      let stepId
      let modelName
      if (this.modelType === 'MVA') {
        modelName = baseData.modelName
        stepId = 'ALL'
      } else {
        modelName = baseData.paramName
        stepId = baseData.stepId
      }

      if (this.maxCondSeq !== null) {
        this.maxCondSeq += 1
      }

      let arr = {
        fab: baseData.fab,
        eqpId: baseData.eqpId,
        moduleId: baseData.moduleId,
        modelName: modelName,
        modelType: this.modelType,
        recipeId: baseData.recipeId,
        stepId: stepId,
        condSeq: this.maxCondSeq,
        contextData: '*',
        contextOptr: 'EQUAL',
        logicOptr: 'AND',
        isNew: true
      }

      this.$refs.modelConditionGrd.addRowOne(arr)
      // let status = {
      //   checked: true,
      //   modified: false,
      //   added: true
      // }
      // this.$refs.modelConditionGrd.addRows(arr, status)
    },
    /**
     * Model Conditino grid column에 data map 설정
     */
    updateComboBoxInGrid () {
      this.getConditionCodeList('CONTEXT_NAME').then((result) => {
        // model type이 MVA 인 경우 contextName code list에서 'STEP' / 'STATUS' 제거
        if (this.modelType === 'MVA') {
          result = result.filter(data => data.contextName !== 'STEP' && data.contextName !== 'STATUS')
        }

        let contextNameList = []
        result.forEach(item => {
          contextNameList.push(item.contextName)
        })
        this.columns.map(c => {
          if (c.field === 'contextName') {
            c.cellEditor = 'agSelectCellEditor'
            c.cellEditorParams = {
              values: contextNameList
            }
          }
          return c
        })
        this.$refs.modelConditionGrd.gridApi.setColumnDefs(this.columns)
      })

      this.getConditionCodeList('CONTEXT_OPTR').then((result) => {
        let contextOptrList = []
        result.forEach(item => {
          contextOptrList.push(item.contextOptr)
        })
        this.columns.map(c => {
          if (c.field === 'contextOptr') {
            c.cellEditor = 'agSelectCellEditor'
            c.cellEditorParams = {
              values: contextOptrList
            }
          }
          return c
        })
        this.$refs.modelConditionGrd.gridApi.setColumnDefs(this.columns)
      })
      this.getConditionCodeList('LOGIC_OPTR').then((result) => {
        let logicOptrList = []
        result.forEach(item => {
          logicOptrList.push(item.logicOptr)
        })
        this.columns.map(c => {
          if (c.field === 'logicOptr') {
            c.cellEditor = 'agSelectCellEditor'
            c.cellEditorParams = {
              values: logicOptrList
            }
          }
          return c
        })
        this.$refs.modelConditionGrd.gridApi.setColumnDefs(this.columns)
      })
    },
    /**
     * Model Condition 관련 code 조회
     * @param {String} codeType code type
     * @returns {Array} code list
     */
    async getConditionCodeList (codeType) {
      let payload = { codeType: codeType }
      var data = await API.Admin.getCodesWithCallback(payload)
      let list = []
      for (var index in data) {
        if (codeType === 'CONTEXT_NAME') {
          list.push({ contextName: data[index].codeId })
        } else if (codeType === 'CONTEXT_OPTR') {
          list.push({ contextOptr: data[index].codeId })
        } else if (codeType === 'LOGIC_OPTR') {
          list.push({ logicOptr: data[index].codeId })
        }
      }
      return list
    },
    /**
     * Model Condition Max Sequence 조회
     * @param {Object} payload 조회 조건
     * @returns {*} Max Sequence value
     */
    async getMaxCondSeq (payload) {
      var data = await API.Model.getModelConditionMaxSeq(payload)
      return data
    },
    /**
     * Model Condition 저장
     */
    async saveData () {
      let self = this
      let allRows = this.$refs.modelConditionGrd.getAllRows()

      if (!this.saveValidation(allRows)) {
        return
      }

      let paramData = this.modelRowData
      let payload
      if (this.modelType === 'MVA') {
        payload = {
          fab: paramData.fab,
          eqpId: paramData.eqpId,
          moduleId: paramData.moduleId,
          modelName: paramData.modelName,
          modelType: this.modelType,
          recipeId: paramData.recipeId,
          stepId: 'ALL',
          modelCondList: allRows
        }
      } else {
        payload = {
          fab: paramData.fab,
          eqpId: paramData.eqpId,
          moduleId: paramData.moduleId,
          modelName: paramData.paramName,
          modelType: this.modelType,
          recipeId: paramData.recipeId,
          stepId: paramData.stepId,
          modelCondList: allRows
        }
      }

      // let message = (mustSaveRows.length) + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_SAVE')
      let message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE') + this.$t('fdc.FAULT_DETECTION.MESSAGE.CONFIRM_CONDITION_SAVE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function saveLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
              self.listFn(self.modelRowData)
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
            }
          }

          // if (mustSaveRows.length > 0) {
          API.Model.saveModelConditions(payload).then(result => {
            saveLastProcess(result)
          })
          // }
        },
        onCancel: function () {}
      })
    },
    /**
     * Save Validation
     * @param {Array} rows row data 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveValidation (rows) {
      for (let i in rows) {
        if (!rows[i].condSeq) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Condition Sequence']))
          return false
        } else if (!rows[i].logicOptr || rows[i].logicOptr.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Logic Operator']))
          return false
        } else if (!rows[i].contextName || rows[i].contextName.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Context Name']))
          return false
        } else if (!rows[i].contextData || rows[i].contextData.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Context Data']))
          return false
        } else if (!rows[i].contextOptr || rows[i].contextOptr.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Context Operator']))
          return false
        }
      }
      return true
    },
    // BRIQUE GRID 관련 method - end
    /**
     * Model Condition 삭제
     */
    async deleteData () {
      let self = this
      // let checkedRows = this.$refs.modelConditionGrd.checkedRows
      let allRows = this.$refs.modelConditionGrd.grid.rows
      let checkedRows = this.getCheckedRows(allRows)

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
        return
      }

      let mustModifiedRows = []

      for (let i in checkedRows) {
        let isCreate = true
        if (!checkedRows[i].isNew) {
          isCreate = false
        }
        // var data = _.clone(checkedRows[i])
        // delete data['_status']
        var data = checkedRows[i]
        if (!isCreate) {
          mustModifiedRows.push(data)
        }
      }

      let message = (mustModifiedRows.length) + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function deleteLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE'))
              self.listFn(self.modelRowData)
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_DELETE'))
            }
          }

          if (mustModifiedRows.length > 0) {
            API.Model.deleteModelConditions(mustModifiedRows).then(result => {
              deleteLastProcess(result)
            })
          }
        },
        onCancel: function () {}
      })
    },
    /**
     * Check된 row 조회
     * @param {Array} allRows all row data
     * @returns {Array} check된 row
     */
    getCheckedRows (allRows) {
      let checkedRows = []
      if (allRows.length > 0) {
        for (var i = 0; i < allRows.length; i++) {
          if (allRows[i].dataItem._status) {
            if (allRows[i].dataItem._status.checked) {
              var data = _.clone(allRows[i].dataItem)
              delete data['_status']
              checkedRows.push(data)
            }
          }
        }
      }
      return checkedRows
    },
    /**
     * Add된 row 조회
     * @param {Array} allRows all row data
     * @returns {Array} add된 row
     */
    getAddedRows (allRows) {
      let addedRows = []
      if (allRows.length > 0) {
        for (var i = 0; i < allRows.length; i++) {
          if (allRows[i].dataItem._status) {
            if (allRows[i].dataItem._status.added) {
              var data = _.clone(allRows[i].dataItem)
              delete data['_status']
              addedRows.push(data)
            }
          }
        }
      }
      return addedRows
    },
    /**
     * Modify된 row 조회
     * @param {Array} allRows all row data
     * @returns {Array} modify된 row
     */
    getModifiedRows (allRows) {
      let modifiedRows = []
      if (allRows.length > 0) {
        for (var i = 0; i < allRows.length; i++) {
          if (allRows[i].dataItem._status) {
            if (allRows[i].dataItem._status.modified) {
              var data = _.clone(allRows[i].dataItem)
              delete data['_status']
              modifiedRows.push(data)
            }
          }
        }
      }
      return modifiedRows
    },
    /**
     * 신규 추가 row Validation
     * @param {Object} params row data
     * @returns {Boolean} Validation 성공 여부
     */
    newRowsKeyValidation (params) {
      let allRows = this.$refs.modelConditionGrd.grid.rows
      let addedRows = this.getAddedRows(allRows)
      let result = true
      let sameDataCnt = 0
      for (var i in addedRows) {
        if (addedRows[i].fab === params.fab &&
          addedRows[i].eqpId === params.eqpId &&
          addedRows[i].moduleId === params.moduleId &&
          addedRows[i].modelName === params.modelName &&
          addedRows[i].modelType === params.modelType &&
          addedRows[i].recipeId === params.recipeId &&
          addedRows[i].stepId === params.stepId &&
          addedRows[i].condSeq === params.condSeq &&
          addedRows[i].condSeq) {
          sameDataCnt++
        }
      }
      if (sameDataCnt > 1) {
        result = false
      }
      return result
    },
    /**
     * Row Select event
     * @param {*} grid
     * @param {*} event
     */
    selectedRow (grid, event) {
      if (grid.selectedItems.length === 1 && !grid.selectedItems[0]._status.added) {
        this.$emit('model-row-selected', grid.selectedItems[0])
      } else {
        this.$emit('model-row-selected', null)
      }
    },
    /**
     * Model Condition 재조회
     */
    refreshData () {
      this.listFn(this.modelRowData)
    },
    /**
     * Row 재배치 (삭제)
     */
    conditionRowDelete () {
      this.$refs.modelConditionGrd.onClickRemoveRow()
    }
  },
  data () {
    return {
      columns: [], // Model Condition grid column 배열
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: [], // Model Condition grid row data
      originRowData: [], // Model Condition grid row data
      maxCondSeq: null // Max Sequence value
    }
  }
}
